module.exports = __webpack_public_path__ + "img/5.e607a3c1.jpg";